<template>
  <div class="datatable-search-wrapper" :class="{showOptions:showOptions}" v-click-outside="clearInput">
    <label :for="name">{{ $t('datatable.search.actions.find') }}</label>
    <div class="input-wrapper">
      <div class="params">
        <span class="params-wrapper" v-for="(param, index) in flatFilters" :key="index">
          <span v-if="index > 0" class="param operator-span">
            <input-select
                v-if="!simpleSelect"
                class="joiner"
                :ref='`query_term_${index}`'
                name="query_term"
                :options="queryOptions"
                :allowEmpty="false"
                :preselectFirst="true"
                :onChange="(value) => onOperatorChange(param, value)"
                :searchable="false"
                :selectedValue="selectedOperator(param)"
              />
              <span v-else class="simple-select-operator">
                OR
              </span>
          </span>
          <span
            class="param"
            :class="{ 'd-flex': isURL(param.label) }"
            @click="removeOption(param)"
          >
            <span class="mr5">{{$t(`datatable.search.types.${param.type}`).toLowerCase()}}</span>
            <span class="mr5">is</span>
            <span
              v-if="isURL(param.label)"
              class="param-label"
            >
              <span class="text-md">
              {{param.label}}
              </span>
            </span>
            <span
              v-else
              class="param-label"
            >
              {{param.label}}
            </span>
          </span>
        </span>
        <span class="params-wrapper">
          <span class="param param-input-wrapper">
            <input
              @keyup="(e) => onInputPageDown(e)"
              class="input-search"
              type="text"
              ref="input"
              :name="name"
              v-model.trim="value"
              v-on:keyup="onSubmit"
              autocomplete="off"
              @focus="onFocusInput"
            >
          </span>
        </span>
      </div>
    </div>
    <span class="clear-search" v-if="flatFilters.length > 0" @click="onClearSearch">
      <i class="fas fa-times"></i>
    </span>

    <span :class='{"clear-search": true, "disabled": flatFilters.length === 0}' @click="onSubmitClick">
      <i class="fas fa-search"></i>
    </span>

    <div
      v-if="showOptions"
      :class="{ 'options-wrapper-larger' : !simpleSelect }"
      class="options-wrapper"
    >
      <div v-if="isBusy">
        <loader :wrapperStyle="loaderWrapperStyle" />
      </div>
      <div v-else>
        <div v-if="options.length > 0">
          <div
            v-for="(option, index) in options"
            :key="index" class="option"
            :ref="`options_${index}`"
            @click.prevent="onClickOption(option)"
          >
            <div class="type">{{$t(`datatable.search.types.${option.type}`)}}</div>
            <input
              v-if="!simpleSelect"
              @blur="(event) => blurOption(event, index)"
              @focus="(event) => foucusOption(event, index)"
              @keydown="(event) => changeOption(event, index)"
              class="name" :ref="`options_input_${index}`"
              :readonly="true"
              :value="option.label"
              @keyup.enter="onClickOption(option)"
            />
            <span v-else>{{ value }}</span>
          </div>
        </div>
        <div v-else>
          <div class="empty-state">
            {{ $t('datatable.search.empty_results') }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Loader from '../components/loader';
import InputSelect from './form-components/input-select';
import FormHelper from '@/helpers/form';

export default {
  props: {
    name: {
      type: String,
      default: 'search'
    },
    filters: Object,
    fields: {
      type: Array,
      default: function() {
        return [];
      }
    },
    data: {
      type: Object,
      default: function() {
        return {};
      }
    },
    dataHeadline: {
      type: Boolean,
      default: false
    },
    dataOutlet: {
      type: Boolean,
      default: false
    },
    simpleSelect: {
      type: Boolean,
      default: false
    },
    isBusy: {
      type: Boolean,
      default: false
    },
    onSearch: {
      type: Function,
      default: function() {
        return;
      }
    },
    onSearchSubmit: {
      type: Function,
      default: function() {
        return;
      }
    },
    countries: {
      type: Array
    },
    states: {
      type: Array
    }
  },

  components: {
    Loader,
    InputSelect
  },

  data: function() {
    return {
      paramsSet: false,
      showOptions: false,
      inputChangeTimeout: null,
      value: '',
      loaderWrapperStyle: {
        height: '90px'
      },
      queryOptions: [{label: 'AND', value: 'and', type: 'query'}, {label: 'OR', value: 'or', type: 'query'}, {label: 'NOT', value: 'not', type: 'query'}],
      filterParams: [
        'media_tag',
        'article_feature',
        'media_feature',
        'article_detail',
        'grouping',
        'source',
        'url',
        'search',
        'coder_id',
        'country_code',
        'user_country_code',
        'keyword',
        'text_in_outlet',
        'text_in_headline',
        'outlet_id',
        'outlet_name',
        'media_type',
        'status_id',
        'article_id',
        'author_id',
        'tag_id',
        'insight_tag_id',
        'languages',
        'coding_uid',
        'source_url',
        'insight_url',
        'relevancy',
        'social'
      ],
      mapOptionKeys: ['outlet', 'media_subtypes', 'countries', 'user_countries', 'coders', 'status', 'free_text', 'tags', 'insight_tags', 'languages', 'coding_uid', 'source_url', 'insight_url', 'authors'],
      singleTypeEntity: []
    }
  },

  computed: {
    isCoderArticlePage() { return this.$route.params.coder_id != undefined },

    options: function() {
      let found = [];
      const { data, value } = this;
      const size = 4;

      Object.keys(data).forEach(property => {
          if (this.simpleSelect) {
            found.push({ type: property, label: '', value: '' });
          } else {
            data[property].forEach(object => {
              const option = { type: property, label: object.label, value: object.value };
              if (
                found.filter(f => f.type == option.type).length < size &&
                this.flatFilters.filter(p => p.type == option.type &&
                p.value == option.value).length == 0
              ) {
                found.push(option);
              }

            });
          }
      });

      if (this.dataHeadline)
        found.unshift( { type: 'text_in_outlet', label: value, value});

      if (this.dataOutlet)
        found.unshift( { type: 'text_in_headline', label: value, value});

      if (this.simpleSelect) return found;

      found.forEach(option => {
        if(this.mapOptionKeys.includes(option.type)) {
          if(option.type === 'outlet') option.type = 'outlet_name'
          if(option.type === 'media_subtypes') option.type = 'media_type'
          if(option.type === 'countries') option.type = 'country_code'
          if(option.type === 'user_countries') option.type = 'user_country_code'
          if(option.type === 'coders') option.type = 'coder_id'
          if(option.type === 'status') option.type = 'status_id'
          if(option.type === 'free_text') option.type = 'keyword'
          if(option.type === 'tags') option.type = 'tag_id'
          if(option.type === 'authors') option.type = 'author_id'
          if(option.type === 'insight_tags') option.type = 'insight_tag_id'
          if(option.type === 'languages') option.type = 'languages'
        }
      })

      return this.removeDuplicateOptions(found)
    },
   
    paramFilters() {
      let filteredFilters = {}
      Object.keys(this.filters).forEach(key => {
        if(this.filterParams.includes(key)) filteredFilters[key] = this.filters[key]
      })
      return filteredFilters
    },
    flatFilters() {
      let arr = []
      Object.keys(this.paramFilters).forEach(key => {
        if(this.paramFilters[key].length) this.paramFilters[key].forEach(filter => {
          filter.type = key
          filter.label = filter.label ? filter.label : filter.value
          arr.push(filter)
        })
      })
      //sort by index
      return arr.sort((item1, item2) => item1.index - item2.index)
    }
  },

  watch: {
    value: function(value) {
      this.onInputChange(value);
    },
  },

  methods: {
    isURL(value) {
      return value && typeof value === 'string' && value.indexOf('https://') !== -1;
    },
    removeDuplicateOptions(options) {
      return options.filter(option => {
        if(!this.flatFilters.length) return true
        const flatFilters = this.flatFilters.filter(filter => filter.type === option.type)
        if(flatFilters.length && flatFilters.find(filter => {
          // media types compare label aginst existing value
          if(option.type === 'media_type') return filter.value === option.label
          // cast string values to int where appropriate
          if(typeof option.value === 'number' && typeof filter.value === 'string')  filter.value = parseInt(filter.value)
          if(typeof filter.value === 'string') return filter.value.toLowerCase() === option.value.toLowerCase()
          return filter.value === option.value
        })) return false
        return true
      });
    },

    removeConstrainedOptions(options) {
      if(this.isCoderArticlePage) return options.filter(option => option.type !== 'coders')
      return options
    },

    selectedOperator(param) {
      const selectedOption =  this.queryOptions.find(option => option.value === param.operator)
      return selectedOption ? selectedOption.value : 'and'
    },

    onInputPageDown: function(e){
      e.preventDefault();
      if(e.key === "ArrowDown" && this.options.length > 0){
        this.$nextTick(function(){
          if(this.$refs[`options_input_${0}`] !== undefined && this.$refs[`options_${0}`] !== undefined){
            this.$refs[`options_input_${0}`][0].focus();
            this.$refs[`options_${0}`][0].classList.add('active-option');
          }            
        });
      }
    },
    changeOption: function(e, index){
      e.preventDefault();

      let i = index;
      if (e.key === "ArrowDown") {
        i++;
        if(this.$refs[`options_input_${i}`] !== undefined){
          this.$refs[`options_input_${i}`][0].focus();  
        } 
      }
      if (e.key === "ArrowUp") {
        i--;
        if (i < 0) {
          this.$refs.input.focus();
        }else if (this.$refs[`options_input_${i}`] !== undefined) {
          this.$refs[`options_input_${i}`][0].focus();
        }        
      }
    },
    blurOption: function(event , index){
      this.$refs[`options_${index}`] !== undefined && this.$refs[`options_${index}`][0].classList.remove('active-option');
    },
    foucusOption: function(event , index){
      this.$refs[`options_${index}`] !== undefined && this.$refs[`options_${index}`][0].classList.add('active-option');
    },
    onInputChange: function(value) {
      const normalizedValue = value.trim().toLowerCase();

      if (normalizedValue.trim() == '') {
        this.showOptions = false;
      }
      else {
        if (normalizedValue != '') {
          this.showOptions = true;
          FormHelper.delayFunction(()=> this.onSearch(normalizedValue), 500, this);
        }
      }
    },

    onOperatorChange: function(param, value) {
      this.$set(param, 'operator', value)
    },

    onClickOption: function(option) {
      let key = option.type
      if(key === 'countries') key = 'country_code'
      if(key === 'user_countries') key = 'user_country_code'
      if(key === 'status') key = 'status_id'
      if(key === 'outlet') key = 'outlet_name'
      if(key === 'free_text') key = 'keyword'
      if(key === 'article') key = 'article_id'
      if(key === 'authors') key = 'author_id'
      if(key === 'tags') key = 'tag_id'
      if(key === 'insight_tags') key = 'insight_tag_id'
      if(key === 'languages') key = 'languages'

      const obj = {
        label: option.label,
        value: this.simpleSelect ? this.value : option.value,
        operator: option.operator || 'and',
        index: this.flatFilters.length
      }

      if(this.singleTypeEntity.includes(option.type)) this.filters[key] = []

      if (!this.filters[key]) this.filters[key] = [];

      this.filters[key].push(obj)


      this.value = '';
      this.$refs.input.focus();   
    },

    removeOption: function(option) {
      if(this.isCoderArticlePage && option.type === "coder_id") return
      const idX = this.filters[option.type].findIndex(filter => filter.value === option.value)
      if(idX !== -1) {
        this.filters[option.type].splice(idX, 1)
      }
      // reset filters only, keep date && groupId if removed all filters
      if(!this.flatFilters.length) this.onSubmitClick()
    },

    onSubmit: function(e) {
      if (e.keyCode === 13) {
        this.onSearchSubmit(this.flatFilters);
      }
    },

    onSubmitClick: function(e) {
      this.onSearchSubmit(this.flatFilters);
    },

    onClearSearch: function() {
      this.value = '';      
      this.onSearchSubmit(null);
    },

    onFocusInput: function() {
      this.onInputChange(this.value);
    },

    clearInput: function() {
      this.onInputChange('');
    }
  }
}
</script>

<style lang="scss" scoped>

  .simple-select-operator {
    padding: 5px 10px;
    color: #efa367;
    font-size: 1rem;
    font-weight: bold;
  };

  .active-option {
    background-color: #EEE;
  }
  .datatable-search-wrapper {
    width: 100%;
    background-color: #FFF;
    display: flex;
    flex-flow: row nowrap;
    align-items: baseline;
    position: relative;
    z-index: 2;
    font-size: 16px;

    &.showOptions {
      z-index: 5;
    }

    label {
      margin: 0 10px 0 0;
      color: #807874;
    }

    .input-wrapper {
      display: flex;
      align-items: center;
      flex-flow: row wrap;

      .params {
        margin-right: 10px;
        margin-left: 10px;
        display: flex;
        align-items: center;
        flex-flow: row wrap;

        .params-wrapper {
          min-height: 35px;
          display: flex;
          align-items: center;
          border-bottom: 1px solid #CCC;
        }

        .param {
          display: flex;
          align-items: baseline;
          cursor: pointer;
          text-transform: uppercase;
          font-size: 0.8rem;

          .param-label {
            text-transform: uppercase;
            font-weight: bold;
            font-size: 0.9rem;

            span {
              white-space: nowrap;
            }
          }

          &:hover {
            background-color: #EEE;
          }

          &.param-input-wrapper {
            margin: 0 5px;
            padding-left: 10px;
          }
        }

        .input-search {
            background-color: initial;
        }

        .operator-span {
          &:hover {
            background-color: initial;
          }
        }

        .joiner {
          color: #efa367;
          font-size: 13px;
          text-transform: uppercase;
          font-weight: 700;
          width: auto;
          min-width: 80px;
          margin: 0 5px;

          :deep(.input-select.multiselect) {
            min-width: 0;

            .multiselect__select {
              top: 50%;
              transform: translateY(-50%);
            }

            .multiselect__tags {
              padding: 4px 30px 4px 4px;
              display: flex;
              align-items: center;
            }
          }
        }
      }
    }

    .clear-search {
      font-size: 13px;
      cursor: pointer;
      padding: 6px 10px;
      flex: 0 0 32px;

      .fas {
        margin-right: 4px;
      }
    }

    input {
      border: none;
      outline: none;
      font-size: 16px;

      &:focus {
        outline: none;
      }
    }

    .options-wrapper {
      position: absolute;
      top: calc(100% - 10px);
      left: 0;
      background-color: #FFF;
      border-top: 1px solid $carma-faint-gray; 
      padding: 0;
      margin: 0;
      list-style-type: none;
      width: 100%;
      padding-top: 10px;
      box-shadow: 0px 5px 4px rgba(0, 0, 0, 0.20);
      z-index: 5;
      max-width: 250px;
      max-height: 500px;
      overflow-x: auto;

      &.options-wrapper-larger {
        max-width: 400px;
      }

      .option {
        display: flex;
        flex-flow: row nowrap;
        align-items: center;
        padding: 6px 10px;

        .type {
          text-transform: uppercase;
          font-weight: 700;
          color: #888;
          font-size: 11px;
          width: 100px;
          flex: 0 0 100px;
          min-width: 100px;
          text-align: right;
          padding-right: 10px;
          box-sizing: border-box;
          margin-top: 5px;
        }

        &:hover {
          background-color: #f1f1f1;
          cursor: pointer;
        }

        .name{
          background-color: inherit;
          cursor: pointer;
          flex: 1 1 auto;
        }

      }

      .empty-state {
        padding: 10px 20px;
        color: #777;
        font-style: italic;
        font-size: 14px;
      }
    }
  }
</style>
